<template>
    <div>
        <HeaderTopComponent  v-if="!menuMovil" />
        <MenuComponent 
            background='' 
            :dense='false' 
            
            styleRow='margin-top: 0px'
            v-if="!menuMovil"
        />
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10'/>
        <BreadCrumbsComponent  :breadcrumbs="breadcrumbs" :class="`margin-breadcrumb ${scrollTop ? '' : 'mt-132'}`"/>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-16 py-2">
            <div class="text-md-h3 text-h4 text-sm-h3 primary--text mt-md-16 font-title"><b><i>TERMINOS Y CONDICIONES</i></b></div>
            <h2 class="gray--text font-title"><i>INNOFARM</i></h2>
            <div class='grayblack--text mt-5'>
                <p>Seguridades que usted debe considerar</p>

                <p>Se recomienda a los clientes, utilizar una contraseña de fácil recordación personal pero difícil de deducir para terceros, nunca revele a nadie su contraseña. Si el cliente comparte su contraseña o información personal con otros, se hace responsable de todas las acciones que se realicen a su nombre en su cuenta. Si la contraseña ha sido comprometida por alguna razón, se recomienda cambiarla inmediatamente. Recuerde que los datos que usted ingresa se considerarán verídicos por lo que INNOFARM S.A. no se responsabiliza por falsedad de la información suministrada por terceros.</p>

                <p>Mantenga el sistema operativo del computador actualizado, así como los antivirus de seguridad de este.</p>

                <p>Existen estafas por medios electrónicos, entre otras formas, pueden utilizar el correo electrónico de los clientes para contactarlos y solicitar información personal. Se recomienda precaución al abrir los enlaces o archivos adjuntos por parte de terceros.</p>

                <p>INNOFARM S.A nunca envía mails solicitando su clave de usuario, número de tarjeta de crédito u otra información personal. En caso de recibir este tipo de correos sugerimos no remitir ninguna información o contactarse con nuestro Servicio al Cliente al 5100700</p>

                <p>Propiedad de contenido</p>

                <p>Todo el contenido del sitio web es propiedad de INNOFARM S.A, por lo que usted no puede copiar, simular, modificar, publicar, registrar, transmitir, reproducir o adaptar cualquier contenido disponible para comunicaciones no autorizadas o de uso comercial sin el consentimiento previo y por escrito de INNOFARM S.A. La información que contiene el sitio web es para uso personal y no comercial.</p>

                <p><b>DEVOLUCIONES</b></p>

                <p>Cualquier devolución que usted solicite deberá realizarce en el local que emitió la factura en un plazo máximo de 24 horas o via telefónica al 5100700.</p>

                <p>Al momento de la entrega del producto, usted deberá validar que todo su pedido esté completo y en perfectas condiciones. Una vez recibido el producto, usted será el responsable del mismo.</p>

                <p><b>ENTREGAS</b></p>

                <p>INNOFARM S.A., con el objetivo  de cumplir con sus tiempos y cobertura a nivel nacional, podrá despachar al usuario del sitio web mercadería proveniente de “Farmacias Innofarm” y , o cualquier otra de la que sea propietario, sin que ello faculte al cliente a presentar algún reclamo a la empresa, por cuanto acepta y entiende que la mercadería es de propiedad de ésta.</p>

                <p>Propiedad intelectual en marcas, logos y contenidos</p>

                <p>Todo el contenido del sitio web  es propiedad de INNOFARM S.A, por lo que usted no puede copiar, simular, modificar, publicar, registrar, transmitir, reproducir o adaptar cualquier contenido disponible para comunicaciones no autorizadas o de uso comercial sin el consentimiento previo y por escrito de INNOFARM S.A. La información que contiene el sitio web es para uso personal y no comercial.</p>

                <p>Jurisdicción y competencia</p>

                <p>En caso de cualquier conflicto respecto al uso o contenido de este aplicativo, las partes renuncian a domicilio y la justicia ordinaria y se someten a mediación y/o arbitraje en la Cámara de Comercio de Quito.</p>
            </div>
            <div class="text-md-h3 text-h4 text-sm-h3 primary--text mt-md-16 font-title"><b><i>POLÍTICAS DE PROTECCIÓN DE DATOS PERSONALES</i></b></div>
            <h2 class="gray--text font-title"><i>INNOFARM</i></h2>
            <div class='grayblack--text mt-5'>
                <p>El titular de los datos acepta y emite su consentimiento unilateral de manera libre y voluntaria para el tratamiento de sus datos personales para que sean: recolectados a través de nuestros canales electrónicos o por cualquier medio, almacenados, procesados, transmitidos y eliminados o para ser objeto de cualquier tratamiento o conjunto de tratamientos a realizar, ya sea por procedimientos técnicos de carácter automatizado, parcialmente automatizado o no automatizados por el Comercio o su delegado, con la finalidad de identificar, actualizar sus datos y ofrecerle servicios y/o productos a través de los canales digitales o cualquier otro medio.</p>

                <p>La transmisión y almacenamiento de la información recopilada por el Comercio o su delegado, será realizada en la infraestructura que este administre, dentro o fuera del territorio ecuatoriano. Esta infraestructura puede ser implementada en servidores físicos o en la nube de proveedores que cuenten con las debidas certificaciones internacionales para el tratamiento de Seguridad de la Información.</p>

                <p>Adicionalmente, mediante la presente el titular de los datos declara conocer y aceptar el Aviso de Política de Privacidad de Place To Play en la cual se indican sus derechos, datos tratados y las actividades comerciales de los aliados, así como otros datos de interés respecto a la protección de datos personales, que se encuentran detallados en el sitio web de Place To Play en la ruta <a target="_blank" href="https://www.placetopay.com/web/politicas-de-privacidad">https://www.placetopay.com/web/politicas-de-privacidad</a> , mediante la cual, se podrá solicitar la gestión de derechos o consentimientos.</p>

                <p>El Comercio o su delegado notificará sobre las actualizaciones del Aviso de Política de Privacidad antes mencionado por medio de los diferentes canales digitales.</p>
            </div>
        </div>
        <FooterComponent />
    </div>
</template>

<script>

import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import MenuMovilComponent from '../partials/MenuMovilComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'
import {mapState} from 'vuex'

export default {
    name: 'FrequentlyAskedQuestionPlaceToPay',
    components:{
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        MenuMovilComponent,
        BreadCrumbsComponent
    },
    data: ()=>({
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Terminos y Condiciones',url:'/terminos-y-condiciones'}
        ],
    }),
    computed:{

        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },

        ...mapState(['scrollTop'])
    }
}

</script>